import {
  BusinessCenter,
  Error,
  OnlinePrediction,
  Verified,
  Receipt,
  AssignmentTurnedIn,
  Cancel,
  FilePresent,
  Sync,
  CurrencyExchange,
  Stars,
  Block,
  ReceiptLong,
  HistoryEdu,
  FactCheck,
  StickyNote2,
  MarkEmailUnread,
  TaskAlt,
  ManageHistory,
  LibraryAddCheck,
} from "@mui/icons-material";
import { Avatar, CircularProgress } from "@mui/material";
import {
  isCompletedOrder,
  isPartialPO,
  isPO,
} from "../helpers/poStateIdentifier";
import { TWO_COLOR_SHADES } from "../theme/shades";

const loadingIcon = <CircularProgress size={28} />;
const shades = TWO_COLOR_SHADES;

const iconSizeConfig = {
  height: 25,
  width: 25,
};

const getValues = (state) => {
  if (state === "loading") {
    return [loadingIcon, loadingIcon, loadingIcon, loadingIcon];
  } else if (state === "error") {
    return [<Cancel />, <Cancel />, <Cancel />, <Cancel />];
  } else if (state === 404) {
    return [0, 0, 0, 0];
  } else {
    return state;
  }
};

export const createInvoiceCards = (status) => {
  return [
    {
      name: "ACCEPTED PO",
      value: getValues(status)[0],
      icon: <Receipt sx={{ height: 30, width: 30 }} />,
      ...TWO_COLOR_SHADES["skyblue"],
    },
    {
      name: "Uploaded Invoices",
      value: getValues(status)[1],
      icon: <LibraryAddCheck sx={{ height: 30, width: 30 }} />,
      ...TWO_COLOR_SHADES["yellow"],
    },

    {
      name: "Completed PO",
      value: getValues(status)[2],
      icon: <LibraryAddCheck sx={{ height: 30, width: 30 }} />,
      ...TWO_COLOR_SHADES["green"],
    },
  ];
};

export const createPOCards = (status) => {
  return [
    {
      name: "Purchase Orders",
      value: getValues(status)[0],
      icon: <BusinessCenter sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["blue"],
    },
    {
      name: "Partial Orders",
      value: getValues(status)[1],
      icon: <Error sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["yellow"],
    },
    {
      name: "Completed",
      value: getValues(status)[2],
      icon: <TaskAlt sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["green"],
    },
    {
      name: "QC Failed",
      value: getValues(status)[3],
      icon: <Cancel sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["red"],
    },
  ];
};

export const createGRNCard = (status) => {
  return [
    {
      unit: "GRN",
      value: getValues(status)[0],
      icon: <AssignmentTurnedIn sx={{ height: 30, width: 30 }} />,
      ...TWO_COLOR_SHADES["pink"],
    },
  ];
};

export const createQCCard = (status) => {
  return [
    {
      name: "QC Approved",
      value: getValues(status)[0],
      icon: <Verified sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["green"],
    },
    {
      name: "QC Pending",
      value: getValues(status)[1],
      icon: <Error sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["yellow"],
    },
    {
      name: "Overall QC Rejected",
      value: getValues(status)[2],
      icon: <Cancel sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["red"],
    },
  ];
};

export const createForecastCard = (status) => {
  return [
    {
      name: "Forecast Orders",
      value: getValues(status)[0],
      icon: <OnlinePrediction sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["blue"],
    },
  ];
};

export const createDashboardCards = (status) => {
  return [
    {
      name: "Purchase Orders",
      value: getValues(status)[0],
      icon: <BusinessCenter sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["skyblue"],
    },
    {
      name: "Quality Check",
      value: getValues(status)[2],
      icon: <AssignmentTurnedIn sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["pink"],
    },
    {
      name: "Uploaded Invoices",
      value: getValues(status)[3],
      icon: <FilePresent sx={{ ...iconSizeConfig }} />,
      ...TWO_COLOR_SHADES["green"],
    },
  ];
};

export const createIcon = (info, usedIn) => {
  return (
    <Avatar
      sx={{
        bgcolor: info.colorTheme.light,
        color: info.colorTheme.dark,
        width: 40,
        height: 40,
        borderRadius: 1,
        ...(usedIn === "todo" && { mr: 1 }),
      }}
      variant="square"
    >
      {info.icon}
    </Avatar>
  );
};

export const getIcon = (todoItem, usedIn) => {
  const iconsSize = {
    height: 25,
    width: 25,
  };
  const notificationIcon ={
    height: 15,
    width: 15,
  }
  switch (todoItem.ModuleName) {
    case "Purchase Order":
      if (todoItem.Action === "Insert") {
        if (todoItem?.Description?.includes("Price Changed")) {
          return createIcon(
            {
              icon: (
                <CurrencyExchange
                  sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }}
                />
              ),
              colorTheme: shades["yellow"],
            },
            usedIn
          );
        } else if (todoItem?.Description?.includes("PO Changed")) {
          return createIcon(
            {
              icon: (
                <ManageHistory sx={{ ...(usedIn === "todo" && iconsSize) }} />
              ),
              colorTheme: shades["yellow"],
            },
            usedIn
          );
        }
        return createIcon(
          {
            icon: <Stars sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["blue"],
          },
          usedIn
        );
      } else if (todoItem.Action === "Update") {
        if (todoItem.Description === "PO Rejected") {
          return createIcon(
            {
              icon: <Block sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
              colorTheme: shades["red"],
            },
            usedIn
          );
        } else if (todoItem.Description === "PO Accepted") {
          return createIcon(
            {
              icon: <Verified sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
              colorTheme: shades["green"],
            },
            usedIn
          );
        }
        return createIcon(
          {
            icon: <Sync sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["green"],
          },
          usedIn
        );
      }
      break;
    case "GRN Order":
      if (todoItem.Action === "Insert") {
        return createIcon(
          {
            icon: <ReceiptLong sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["green"],
          },
          usedIn
        );
      } else if (todoItem.Action === "Update") {
        return createIcon(
          {
            icon: <HistoryEdu sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["yellow"],
          },
          usedIn
        );
      }
      break;
    case "QC Screen":
      if (todoItem.Action === "Insert") {
        return createIcon(
          {
            icon: <StickyNote2 sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["skyblue"],
          },
          usedIn
        );
      } else if (todoItem.Action === "Update") {
        return createIcon(
          {
            icon: <FactCheck sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["yellow"],
          },
          usedIn
        );
      }
      break;
    case "Invoice Screen":
      if (todoItem.Action === "Update") {
        return createIcon(
          {
            icon: <Receipt sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["green"],
          },
          usedIn
        );
      } else if (todoItem.Action === "Insert"){
        return createIcon(
          {
            icon: <Receipt sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />,
            colorTheme: shades["green"],
          },
          usedIn
        );
      }
      break;
    default:
      return createIcon(
        {
          icon: (
            <MarkEmailUnread sx={{ ...(usedIn === "todo" ? iconsSize : notificationIcon ) }} />
          ),
          colorTheme: shades["green"],
        },
        usedIn
      );
  }
};

export const createHeading = (todoItem) => {
  switch (todoItem.ModuleName) {
    case "Purchase Order":
      if (todoItem.Action === "Insert") {
        if (
          todoItem.Description &&
          todoItem.Description.includes("Price Changed")
        ) {
          return "Price change request";
        }
        return "New purchase order raised";
      } else if (todoItem.Action === "Update") {
        if (todoItem.Description === "PO Rejected") {
          return "Purchase order rejected";
        } else if (todoItem.Description === "PO Accepted") {
          return "Purchase order accepted";
        }
        return "Purchase order updated";
      }
      break;
    case "GRN Order":
      if (todoItem.Action === "Insert") {
        return "New GRN created";
      } else if (todoItem.Action === "Update") {
        return "GRN updated";
      }
      break;
    case "QC Screen":
      if (todoItem.Action === "Insert") {
        return "New quality check";
      } else if (todoItem.Action === "Update") {
        return "Quality check status updated";
      }
      break;
    case "Invoice Screen":
      if (todoItem.Action === "Update") {
        return "Invoice uploaded";
      }
      break;
    default:
      return "New notification";
  }
};

export const createMessage = (todoItem) => {
  switch (todoItem.ModuleName) {
    case "Purchase Order":
      if (todoItem.Action === "Insert") {
        if (todoItem?.Description?.includes("Price Changed")) {
          return `${todoItem.Description}`;
        } else if (todoItem?.Description?.includes("PO Changed")) {
          return `${todoItem.Description}`;
        } else if (todoItem?.Description?.includes("PO Comment")) {
          return `${todoItem.Description}`;
        }
        return ` ${todoItem.Description}`;
      } else if (todoItem.Action === "Update") {
        if (todoItem.Description === "PO Rejected") {
          return `${todoItem.Description}`;
        } else if (todoItem.Description === "PO Accepted") {
          return `${todoItem.Description}`;
        }
        return `${todoItem.Description}`;
      }
      break;
    case "GRN Order":
      if (todoItem.Action === "Insert") {
        return `${todoItem.Description}`;
      } else if (todoItem.Action === "Update") {
        return `${todoItem.Description}`;
      }
      break;
    case "QC Screen":
      if (todoItem.Action === "Insert") {
        return `${todoItem.Description}`;
      } else if (todoItem.Action === "Update") {
        return `${todoItem.Description}`;
      }
      break;
    case "Invoice Screen":
      if (todoItem.Action === "Update") {
        return `${todoItem.Description}`;
      }
      break;
    default:
      return `${todoItem.Description}`;
  }
};

export const getPOCardCount = (data, reject = []) => {
  var totalpurchase = 0;
  var partial = 0;
  var duethisweek = 0;
  for (const item of data) {
    if (isPO(item)) {
      totalpurchase++;
    }
    if (isPartialPO(item)) {
      partial++;
    }
    if (isCompletedOrder(item)) {
      duethisweek++;
    }
  }
  return [totalpurchase, partial, duethisweek, reject.length];
};

export const getQCCardCount = (data, rejectedQC = []) => {
  var pendingQC = 0;
  var completeQC = 0;
  for (const qc of data) {
    if (qc && qc.QCRemarks === "Qc Done") {
      completeQC += 1;
    } else pendingQC += 1;
  }
  return [completeQC, pendingQC, rejectedQC.length];
};
